import { z } from 'zod';
import { AttachmentInput, ContentBase, GeoLocation } from './content.js';
import { Taxonomy } from './taxonomy.js';
// ── Polls (FR-POLL-01…08) ──────────────────────────────────────────────────
export const PollOption = z.object({
    id: z.string(),
    text: z.string(),
    votes: z.number().int().nonnegative(),
});
export const PollView = ContentBase.extend({
    type: z.literal('poll'),
    options: z.array(PollOption).min(2).max(10),
    totalVotes: z.number().int().nonnegative(),
    /** Absent when Q-17 is unresolved / poll never closes. */
    closesAt: z.coerce.date().nullable(),
    duration: z.enum(['1d', '3d', '7d']),
    /** The viewer's choice, when known. */
    myVote: z.string().nullable().optional(),
});
export const VoteInput = z.object({ optionId: z.string() });
// ── Fundraisers (FR-FUND-01…09) ────────────────────────────────────────────
export const CreateFundraiserInput = Taxonomy.extend({
    title: z.string().min(1).max(120),
    cause: z.string().min(1).max(5_000),
    /** Optional goal — Q-18 unresolved, so a fundraiser may run without one. */
    goalMinor: z.number().int().positive().optional(),
    currency: z
        .string()
        .length(3)
        .regex(/^[A-Z]{3}$/)
        .default('USD'),
    endsAt: z.coerce.date().optional(),
    commentsEnabled: z.boolean().default(true),
    opvEnabled: z.boolean().default(true),
    location: GeoLocation.optional(),
    hashtags: z.array(z.string()).max(30).default([]),
    attachments: z.array(AttachmentInput).max(10).default([]),
    scheduledAt: z.coerce.date().optional(),
});
export const FundraiserView = ContentBase.extend({
    type: z.literal('fundraiser'),
    cause: z.string(),
    goalMinor: z.number().int().positive().nullable(),
    raisedMinor: z.number().int().nonnegative(),
    donorCount: z.number().int().nonnegative(),
    currency: z.string().length(3),
    endsAt: z.coerce.date().nullable(),
});
export const DonateInput = z.object({
    amountMinor: z.number().int().min(100).max(1_000_000_00),
    methodId: z.string().optional(),
    /** Client-generated; makes the donation idempotent on retry. */
    idempotencyKey: z.string().min(8).max(100),
});
export const DonationResult = z.object({
    paymentId: z.string(),
    fundraiserId: z.string(),
    amountMinor: z.number().int(),
    status: z.enum(['succeeded', 'failed']),
    failureReason: z.string().nullable(),
});
/** My Donors row (FR-FUND-08). */
export const DonorRow = z.object({
    userId: z.string(),
    displayName: z.string().nullable(),
    totalMinor: z.number().int().nonnegative(),
    mutualCount: z.number().int().nonnegative(),
    lastDonatedAt: z.coerce.date(),
});
//# sourceMappingURL=civic.js.map